import React, { useState } from 'react'
import moment, { Moment } from 'moment'
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined'
import { Popover } from '@mui/material'
import { colors } from '@resiliatech/birdsong'
import { DateRangeContainer } from '../DashboardFilters/DashboardFilters.styled'
import { DatePicker } from '../../../../SharedComponents/DatePicker/DatePicker'
import { ISO_8601_DATE_FORMAT } from '../utils'
import { CheckListItemWithGoalInfo } from '../types'

type TaskDueDateProps = {
  onChangeTaskDueDate: (date: Moment | null) => void
  task: CheckListItemWithGoalInfo
}

export const TaskDueDate = ({
  onChangeTaskDueDate,
  task,
}: TaskDueDateProps) => {
  const taskDueDate = task?.dueDate
    ? moment.utc(moment(task.dueDate, ISO_8601_DATE_FORMAT))
    : null
  const [dueDate, setDueDate] = useState<Moment | null>(taskDueDate)
  const [anchorEl, setAnchorEl] = useState<
    (EventTarget & SVGSVGElement) | null
  >(null)
  const open = Boolean(anchorEl)

  const handleChangeDueDate = (date: Moment | null) => {
    try {
      onChangeTaskDueDate(date)
      setDueDate(date)
      setAnchorEl(null)
    } catch {
      setDueDate(taskDueDate)
    }
  }

  return (
    <>
      <CalendarTodayOutlinedIcon
        onClick={(event) => setAnchorEl(event.currentTarget)}
      />
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <DateRangeContainer>
          <DatePicker
            date={dueDate}
            label='Due Date'
            onDateSelected={(m) => handleChangeDueDate(m ?? null)}
            styles={{ backgroundColor: colors.background.secondaryBackground }}
          />
        </DateRangeContainer>
      </Popover>
    </>
  )
}
